import React from 'react'

import { useCaptionStyles } from './caption.style'

export const Caption = function Caption ({ children }) {
  const classes = useCaptionStyles()

  return (
    <div className={classes.caption}>
      <div className={classes.captionText}>
        {children}
      </div>
    </div>
  )
}
